/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';
import { ContactFields, AppointmentFields, AvailableServiceFields } from './fragments';

export const LOGIN_PASSCODE = gql`
  mutation loginUser($input: LoginWithPasscodeInput!) {
    loginWithPasscode(input: $input) {
      accessToken
      refreshToken
      accessUnixExpiration
      viewer {
        firstName
        lastName
        email
        isViewer
        accounts {
          virtualPhoneNumbers {
            id
            phoneNumber
            friendlyName
          }
        }
        sessions {
          id
          deviceName
        }
      }
    }
  }
`;

export const REG_USER_CHECKIN = gql`
  mutation checkin($input: CheckInEventRegistrationInput!) {
    checkInEventRegistration(input: $input) {
      registration {
        status
        attendee {
          id
          firstName
          lastName
          zipCode {
            value
          }
          gender
          birthday
          primaryPhoneNumber {
            number
          }
        }
        event {
          id
          type
          title
        }
      }
    }
  }
`;

export const SUBMIT_OPT_IN_FORM = gql`
  mutation createContactViaOptInForm($input: CreateContactViaOptInFormInput!) {
    createContactViaOptInForm(input: $input) {
      contact {
        ...ContactFields
      }
    }
  }
  ${ContactFields}
`;

export const SUBMIT_BOOKING = gql`
  mutation createInstantBooking($input: CreateInstantBookingInput!) {
    createInstantBooking(input: $input) {
      instantBooking {
        id
        priceCents
        appointment {
          ...AppointmentFields
        }
        service {
          ...AvailableServiceFields
        }
        contact {
          ...ContactFields
        }
      }
    }
  }
  ${ContactFields}
  ${AppointmentFields}
  ${AvailableServiceFields}
`;

export const SUBMIT_RSVP = gql`
  mutation createRegistration($input: RegisterAttendeeForRsvpEventInput!) {
    registerAttendeeForRsvpEvent(input: $input) {
      registration {
        id
        attendee {
          id
          firstName
          lastName
          zipCode {
            value
          }
          gender
          birthday
        }
        event {
          id
          type
          title
        }
      }
    }
  }
`;
